import { render, staticRenderFns } from "./addPersonPopup.vue?vue&type=template&id=f3116122&scoped=true&"
import script from "./addPersonPopup.vue?vue&type=script&lang=js&"
export * from "./addPersonPopup.vue?vue&type=script&lang=js&"
import style0 from "./addPersonPopup.vue?vue&type=style&index=0&id=f3116122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3116122",
  null
  
)

export default component.exports